import {
  Directive,
  Input,
  HostBinding,
  HostListener,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { KeyboardService } from '../keyboard/keyboard.service';

@Directive({
  selector: '[appKeyboardKey]',
})
export class KeyboardDirective implements OnInit, OnDestroy {
  private _values: string[] = [];
  private isShifted: boolean = false;
  private isAlt: boolean = false;

  @Input('appKeyboardKey') values: string = "";

  @HostBinding('innerText') currentValue: string = "";

  constructor(private keyboard: KeyboardService) {}

  ngOnInit() {
    this._values = this.values.split(' ');
    this.currentValue = this._values[0];

    this.keyboard.shiftChanged.subscribe((shift) => {
      this.isShifted = shift;
      this.updateCurrentValue();
    });
    this.keyboard.altChanged.subscribe((alt) => {
      this.isAlt = alt;
      this.updateCurrentValue();
    });
  }

  ngOnDestroy() {}

  updateCurrentValue() {
    if (!this.isAlt) {
      if (!this.isShifted) {
        this.currentValue = this._values[0];
      } else {
        this.currentValue = this._values[0].toUpperCase();
      }
    } else {
      if (!this.isShifted) {
        this.currentValue = this._values[1];
      } else {
        this.currentValue = this._values[2];
      }
    }
  }

  @HostListener('click')
  onClick() {
    this.keyboard.fireKeyPressed(this.currentValue);
  }
}

// import {
//   Directive,
//   Input,
//   HostListener,
//   OnInit,
//   OnDestroy,
//   ElementRef,
//   Renderer2
// } from '@angular/core';
// import { Subscription } from 'rxjs';
// import { KeyboardService } from '../keyboard/keyboard.service';
// //2025-07-29 - MY -OC-283
// // removed @HostBinding - it may not trigger a repaint or reflow
// // instead trying to use Renderer2.setProperty() to directly update the DOM and forces rendering
// //If shiftChanged or altChanged emit outside of Angular’s zone, the @HostBinding update might not happen immediately
// @Directive({
//   selector: '[appKeyboardKey]',
// })
// export class KeyboardDirective implements OnInit, OnDestroy {
//   private _values: string[] = [];
//   private isShifted: boolean = false;
//   private isAlt: boolean = false;
//   private currentValue: string = '';

//   //2025-07-29 - MY -OC-283
//   //introduce new variable just so we can Unsubscribes
//   private shiftSub!: Subscription;
//   private altSub!: Subscription;

//   @Input('appKeyboardKey') values: string = '';

//   constructor(
//     private keyboard: KeyboardService,
//     private renderer: Renderer2,
//     private el: ElementRef
//   ) {}

//   ngOnInit() {
//     this._values = this.values.split(' ');
//     this.updateCurrentValue();

//     //Subscribes to the shared KeyboardService and set it to this.shiftSub
//     this.shiftSub = this.keyboard.shiftChanged.subscribe((shift) => {
//       this.isShifted = shift;
//       this.updateCurrentValue();
//     });

//     this.altSub = this.keyboard.altChanged.subscribe((alt) => {
//       this.isAlt = alt;
//       this.updateCurrentValue();
//     });
//   }

//   //Unsubscribes to prevent memory leaks
//   ngOnDestroy() {
//     this.shiftSub?.unsubscribe();
//     this.altSub?.unsubscribe();
//   }

//   private updateCurrentValue() {
//     //Determines which key value to use
//     if (this.isAlt && this._values.length > 2) {
//       this.currentValue = this._values[2];
//     } else if (this.isShifted && this._values.length > 1) {
//       this.currentValue = this._values[1];
//     } else {
//       this.currentValue = this._values[0];
//     }

//     //here wetry to directly update the DOM to show the correct key value on the button
//     this.renderer.setProperty(this.el.nativeElement, 'innerText', this.currentValue);
//   }

//   @HostListener('click')
//   onClick() {
//     this.keyboard.fireKeyPressed(this.currentValue);
//   }
// }
